import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const MobileHomeLocation = ({ mobilehomeLocation }: SpecProps<"mobilehome_location">) => {
  const { i18n } = useLingui();

  if (!mobilehomeLocation) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.mobilehomeLocation",
    message: "The Mobile home is in",
    comment: "Field for 'mobile home location' in ad specification",
  });
  return <FieldValuePair field={field} value={mobilehomeLocation} />;
};
